import { formDataRequest, postRequest } from "../libs/AxiosService.util";

export async function serviceBlockedUserList(params) {
  return await postRequest("whatsapp/users/blocked", params);
}
export async function serviceUnBlockUser(params) {
  return await postRequest("whatsapp/users/unblock", params);
}
